import React, { Component } from 'react';
import { Label, InputGroup,InputGroupText,InputGroupAddon} from 'reactstrap';

class SelectNormal extends Component {
	render () {
		return (
			<InputGroup className={`mb-3 ${this.props.className ? this.props.className : ''}`}>
				{
					this.props.label_text?
						<Label className="text-muted w100"> 
						{this.props.label_text}
						{ this.props.required ? <i style={{color:'red'}}> *</i> :null }
						</Label>
					:null
				}
				{ 	
						/* Coloca un icono o caracter antes del input*/
						this.props.iconPrepend?
						<InputGroupAddon addonType="prepend">
							<InputGroupText>
								{this.props.iconPrepend}
							</InputGroupText>
						</InputGroupAddon>
						:
						null
					}
				
				<select name={this.props.name?this.props.name : undefined } disabled={this.props.disabled} className="form-control" onChange={this.props.onchange} style={{ height: `${this.props.customHeight}` }} value={this.props.val?this.props.val:''}>
					{
						this.props.text_init?
							<option value="">{this.props.text_init }</option>
						:null
					}
					
					{
						this.props.options?
							this.props.options.map( (option, key) => {
								return (<option key={ key } value={ option.value ? option.value : option.id }> { option.name } </option>)
							})
						:
						null
					}
				</select>
				{
					this.props.buttonAppend?
						<InputGroupAddon addonType="append">
						{this.props.buttonAppend}
						</InputGroupAddon>
					:null
				}
				
			</InputGroup>
		)
		
	}
}

export default SelectNormal;



// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SelectNormal.js